import React, { useState, useEffect } from 'react';

function App() {
  const [hwids, setHwids] = useState([]);
  const [login, setLogin] = useState({ password: '' });
  const [authenticated, setAuthenticated] = useState(false);
  const [newHWID, setNewHWID] = useState('');

  const backendURL = 'https://hwid-worker.footeater69420.workers.dev';

  const fetchHWIDs = async () => {
    const res = await fetch(`${backendURL}/api/hwids`);
    if (res.ok) {
      const data = await res.json();
      setHwids(data);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    const res = await fetch(`${backendURL}/api/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ password: login.password, username: 'admin' })
    });
    if (res.ok) {
      setAuthenticated(true);
      fetchHWIDs();
    } else {
      alert('Login failed');
    }
  };

  const handleAddHWID = async (e) => {
    e.preventDefault();
    const res = await fetch(`${backendURL}/api/hwids`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ hwid: newHWID })
    });
    if (res.ok) {
      setNewHWID('');
      fetchHWIDs();
    } else {
      const data = await res.json();
      alert(data.message);
    }
  };

  if (!authenticated) {
    return (
      <div style={{ padding: '2rem', fontFamily: 'Arial' }}>
        <h2>Admin Login</h2>
        <form onSubmit={handleLogin}>
          <input
            type="password"
            placeholder="Admin Password"
            value={login.password}
            onChange={e => setLogin({ password: e.target.value })}
          />
          <button type="submit" style={{ marginLeft: '1rem' }}>Login</button>
        </form>
      </div>
    );
  }

  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial' }}>
      <h2>HWID Dashboard</h2>
      <h3>Current HWIDs:</h3>
      <ul>
        {hwids.map(h => <li key={h}>{h}</li>)}
      </ul>
      <h3>Add New HWID:</h3>
      <form onSubmit={handleAddHWID}>
        <input
          placeholder="New HWID"
          value={newHWID}
          onChange={e => setNewHWID(e.target.value)}
        />
        <button type="submit" style={{ marginLeft: '1rem' }}>Add HWID</button>
      </form>
    </div>
  );
}

export default App;
